import React from "react";

const subFeatures = [
  {
    icon: "/section2-icon.webp",
    title: "10k+ satisfied customer",
    description:
      "Join a community of 10K+ satisfied customers leveraging our software's capabilities across 7 countries and counting.",
  },
  {
    icon: "/section2-icon2.webp",
    title: "50+ skilled developer",
    description:
      "Our 50+ skilled developers drive excellence, enabling us to create cutting-edge software solutions for diverse needs.",
  },
  {
    icon: "/section2-icon2.webp",
    title: "7+ countries",
    description: "We impact across 7+ countries, revolutionizing industries and fostering global connections."
  },
  {
    icon: "/section2-icon.webp",
    title: "$5M+ revenue",
    description:
      "Join our global apps market network as we've grown from ground zero to a $5M revenue in less than 3 years"
  },
];

const ModernLayout = () => {
  return (
    <section className="py-20 bg-white px-4 max-w-6xl mx-auto">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Image */}
        <div className="bg-[#F4F0FD] rounded-2xl p-4 flex justify-center">
          <img
            src="/section2.png"
            alt="Modern Layout Preview"
            className=" max-w-full"
          />
        </div>

        {/* Right Content */}
        <div>
          {/* Badge */}
          <span className="text-[11px] bg-[#E6F5E8] text-[#137547] font-semibold px-4 py-1 rounded-full inline-block mb-4 tracking-wide uppercase">
            Our History
          </span>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A033C] mb-6 leading-snug">
            Explore Our Company's Statistical Insights
          </h2>

          {/* Paragraph */}
          <p className="text-[#6B7280] text-base leading-relaxed mb-8 border-b border-gray-200 pb-8">
            Choose a template, tailor it to match your brand, and launch your website with ease. Our drag-and-drop builder makes customization simple — no coding needed.
          </p>

          {/* Sub Features */}
          <div className="grid sm:grid-cols-2 gap-6">
            {subFeatures.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <img src={item.icon} alt={item.title} className="h-15 mt-1" />
                <div>
                  <h3 className="text-lg font-bold text-[#0A033C] mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#444] leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernLayout;
